@if ((browserSupportService.isBrowserSupported | async) === false) {
  <div id="{{modalContainerId}}">
    <div id="browser-support-modal" class="vtz-modal">
      <img class="vtz-modal-icon" i18n-alt="icon alert alt-text" alt="icon alert" src="/assets/images/icon_alert.svg" />
      <div id="browser-support-modal-content" class="vtz-modal-content">
        <span i18n class="vtz-modal-title">Browser Not Supported</span>
        <span i18n class="vtz-modal-body vtz-modal-body--wide">{{message | async}}</span>
      </div>
    </div>
    <div i18n id="browser-support-modal-backdrop" class="vtz-modal-backdrop"></div>
  </div>
}
